///ts:ref=PandaError
/// <reference path="../utils/PandaError.ts"/> ///ts:ref:generated
namespace UserAgentParser {
	export class ParseResult {
		public userAgent:string = 'unknown';
		public browser: string = 'unknown';
		public versionNumber: number = 0;
		public version: string = 'unknown'
		public parentBrowser: string = 'unknown'
		public parentVersion: string = 'unknown'
		public parentVersionNumber: number = 0;
		public osType: string = 'unknown';
		public osName: string = 'unknown';
		public osVersion: string = 'unknown';
		public osVersionNumber: number = 0;
		public archtecture: string = 'unknown';
		public parsedCorretly:boolean = false;
		public fatalParsingError:boolean = false;
		public mobileExperimental:boolean = null;
		public products:Array<Extended.Product> = [];
		public comments:Array<Extended.CommentToken> = [];
		
		private _productHash: any;
		public getFirstProductByName(name:string):Extended.Product {
			if (!this._productHash) {
				this._productHash = new Object();
				for (let product of this.products) {
					if (!this._productHash[product.browser]) {
						this._productHash[product.browser] = product;
					}
				}
				for (let token of this.comments) {
					if (token instanceof Extended.CommentProductToken) {
						let product:Extended.Product = token.product;
						if (!this._productHash[product.browser]) {
							this._productHash[product.browser] = product;
						}
					}
				}
			}
			return this._productHash[name];
		}
	}

	export function parse(agent: string): ParseResult {
		PandaConsole.here;
		let result: ParseResult = new ParseResult();
		result.userAgent = agent;
		try {
			let splitted:Internal.SplitterResult = Internal.splitAgent(agent, false);
			if (!splitted) {
				result.fatalParsingError = true;
				return result;
			}

			result.products = Internal.parseProducts(splitted);
			result.comments = Internal.parseComments(splitted);

			Internal.fillOSProperties(result);
			Internal.fillBrowserProperties(result);

		} catch (splittingError) {
			PandaConsole.errorUncritical(splittingError);
		}
		return result;
	}

	export namespace Extended {
		export class Product {
			public raw:string;
			public browser: string = 'unknown';
			public versionNumber: number = 0;
			public version: string = 'unknown';
		}

		export class CommentToken {
			public raw:string;
		}

		export class CommentUnknownToken extends CommentToken {
		}

		export class CommentOSToken extends CommentToken {
			public osType: string;
			public osName: string;
			public osVersion: string;
			public osVersionNumber: number;
			public architecture:string;
		}

		export class CommentArchitectureToken extends CommentToken {
		}

		export class CommentProductToken extends CommentToken {
			public product: Product;
		}

		export class CommentVersionToken extends CommentToken {
			public version: string;
			public versionNumber: number;
		}
	}

	export namespace Internal {
		export class ParseProductError extends PandaError {
			constructor(message: string, code:number = 0) {
				super(message, code, true);
			}
		}
		export class SplitError extends PandaError {
			constructor(message: string, code:number = 0) {
				super(message, code, true);
			}
		}

		export namespace ProductName {
			export const Opera:string = 'Opera';
			export const Version:string = 'Version';
			export const Chrome:string = 'Chrome';
			export const Edge:string = 'Edge';
			export const AppleWebKit:string = 'AppleWebKit';
			export const Safari:string = 'Safari';
			export const Mozilla:string = 'Mozilla';
			export const OPR:string = 'OPR';
			export const YaBrowser:string = 'YaBrowser';
			export const Yowser:string = 'Yowser';
			export const Gecko:string = 'Gecko';
			export const Firefox:string = 'Firefox';
			export const Nichrome:string = 'Nichrome';
			export const Amigo:string = 'Amigo';
			export const Trident:string = 'Trident';
			export const MSIE:string = 'MSIE';
			export const CanvasFrame:string = 'CanvasFrame';
			export const PaleMoon:string = 'PaleMoon';
			export const Goanna:string = 'Goanna';
			export const AOL:string = 'AOL';
			export const AOLBuild:string = 'AOLBuild';
			export const Mobile:string = 'Mobile';
			export const CriOS:string = 'CriOS';
			export const FxiOS:string = 'FxiOS';
			export const AdobeAIR:string = 'AdobeAIR';
		}

		export function fillBrowserProperties(result:ParseResult):void {
			PandaConsole.here;
			let testers:Array<(result:ParseResult)=>boolean> = [
				tryChrome, // обязательно сначала хром, наследники хрома на него опираются
				tryEdge,
				tryFirefox,
				tryOldOpera, 
				tryNewOpera,
				tryYandex,
				tryFacebook,
				tryIE,
				trySafari,
				tryAir,
				tryChromeIos,
				tryFirefoxIos,
				tryPaleMoon,
				tryAol,
				tryOneProductGoogleExtender,
				tryOneProductFirefoxExtender,
			];
			for (let func of testers) {
				let stopTrying:boolean = func(result);
				if (stopTrying) {
					break;
				}
				if (result.parsedCorretly) {
					break;
				}
			}
		}

		export function tryOldOpera(result:ParseResult):boolean {
			let opera:Extended.Product = result.getFirstProductByName(ProductName.Opera);
			if (!opera) {
				return false;
			}
			let version:Extended.Product = result.getFirstProductByName(ProductName.Version);
			if (!version) {
				PandaConsole.errorUncritical(new PandaError('Old Opera without version', 130));
				return false;
			}
			result.browser = opera.browser;
			result.version = version.version;
			result.versionNumber = version.versionNumber;
			result.parentBrowser = opera.browser;
			result.parentVersion = version.version;
			result.parentVersionNumber = version.versionNumber;
			if (result.products.length === 3) {
				result.parsedCorretly = true;
			}
			return true;
		}

		export function tryChrome(result:ParseResult):boolean {
			let chrome:Extended.Product = result.getFirstProductByName(ProductName.Chrome);
			if (!chrome) {
				return false;
			}
			let edge:Extended.Product = result.getFirstProductByName(ProductName.Edge);
			if (edge) {
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('Chrome without Mozilla', 131));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('Chrome with mozilla version !==5', 132));
				return false;
			}
			let webKit:Extended.Product = result.getFirstProductByName(ProductName.AppleWebKit);
			if (!webKit) {
				PandaConsole.errorUncritical(new PandaError('Chrome without AppleWebKit', 133));
				return false;
			}
			let safari:Extended.Product = result.getFirstProductByName(ProductName.Safari);
			if (!safari) {
				PandaConsole.errorUncritical(new PandaError('Chrome without Safari', 134));
				return false;
			}

			result.browser = chrome.browser;
			result.version = chrome.version;
			result.versionNumber = chrome.versionNumber;
			result.parentBrowser = chrome.browser;
			result.parentVersion = chrome.version;
			result.parentVersionNumber = chrome.versionNumber;

			if (result.products.length === 4) {
				result.parsedCorretly = true;
			}

			return false;
		}

		export function tryChromeIos(result:ParseResult):boolean {
			let crios:Extended.Product = result.getFirstProductByName(ProductName.CriOS);
			if (!crios) {
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('CriOS without Mozilla', 131));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('CriOS with mozilla version !==5', 132));
				return false;
			}
			let webKit:Extended.Product = result.getFirstProductByName(ProductName.AppleWebKit);
			if (!webKit) {
				PandaConsole.errorUncritical(new PandaError('CriOS without AppleWebKit', 133));
				return false;
			}
			let safari:Extended.Product = result.getFirstProductByName(ProductName.Safari);
			if (!safari) {
				PandaConsole.errorUncritical(new PandaError('CriOS without Safari', 134));
				return false;
			}
			let mobile:Extended.Product = result.getFirstProductByName(ProductName.Mobile);
			if (!mobile) {
				PandaConsole.errorUncritical(new PandaError('Mobile without Safari', 134));
				return false;
			}

			result.browser = 'Chrome';
			result.version = crios.version;
			result.versionNumber = crios.versionNumber;
			result.parentBrowser = 'Chrome';
			result.parentVersion = crios.version;
			result.parentVersionNumber = crios.versionNumber;
			result.mobileExperimental = true;

			if (result.products.length === 5) {
				result.parsedCorretly = true;
			}

			return false;
		}

		export function tryFirefoxIos(result:ParseResult):boolean {
			let fxiOS:Extended.Product = result.getFirstProductByName(ProductName.FxiOS);
			if (!fxiOS) {
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('FxiOS without Mozilla', 131));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('FxiOS with mozilla version !==5', 132));
				return false;
			}
			let webKit:Extended.Product = result.getFirstProductByName(ProductName.AppleWebKit);
			if (!webKit) {
				PandaConsole.errorUncritical(new PandaError('FxiOS without AppleWebKit', 133));
				return false;
			}
			let safari:Extended.Product = result.getFirstProductByName(ProductName.Safari);
			if (!safari) {
				PandaConsole.errorUncritical(new PandaError('FxiOS without Safari', 134));
				return false;
			}
			let mobile:Extended.Product = result.getFirstProductByName(ProductName.Mobile);
			if (!mobile) {
				PandaConsole.errorUncritical(new PandaError('Mobile without Safari', 134));
				return false;
			}

			result.browser = 'Firefox';
			result.version = fxiOS.version;
			result.versionNumber = fxiOS.versionNumber;
			result.parentBrowser = 'Firefox';
			result.parentVersion = fxiOS.version;
			result.parentVersionNumber = fxiOS.versionNumber;
			result.mobileExperimental = true;

			if (result.products.length === 5) {
				result.parsedCorretly = true;
			}

			return false;
		}

		export function tryNewOpera(result:ParseResult):boolean {
			let opr:Extended.Product = result.getFirstProductByName(ProductName.OPR);
			if (!opr) {
				return false;
			}
			if (result.parentBrowser !== ProductName.Chrome) {
				PandaConsole.errorUncritical(new PandaError('New Opera without Chrome', 134));
				return false;
			}

			result.browser = ProductName.Opera;
			result.version = opr.version;
			result.versionNumber = opr.versionNumber;

			if (result.products.length === 5) {
				result.parsedCorretly = true;
			}
			return true;
		}

		export function tryEdge(result:ParseResult):boolean {
			let edge:Extended.Product = result.getFirstProductByName(ProductName.Edge);
			if (!edge) {
				return false;
			}

			result.browser = edge.browser;
			result.version = edge.version;
			result.versionNumber = edge.versionNumber;

			if (result.products.length === 5) {
				result.parsedCorretly = true;
			}

			result.parentBrowser = edge.browser;
			result.parentVersion = edge.version;
			result.parentVersionNumber = edge.versionNumber;

			return true;
		}

		export function tryYandex(result:ParseResult):boolean {
			let yabrowser:Extended.Product = result.getFirstProductByName(ProductName.YaBrowser);
			if (!yabrowser) {
				return false;
			}

			if (result.parentBrowser !== ProductName.Chrome) {
				PandaConsole.errorUncritical(new PandaError('Yabrowser without Chrome', 135));
				return false;
			}

			result.browser = yabrowser.browser;
			result.version = yabrowser.version;
			result.versionNumber = yabrowser.versionNumber;

			let yozer:Extended.Product = result.getFirstProductByName(ProductName.Yowser);
			if ((result.products.length === 5 && yozer === undefined) || (result.products.length === 6 && yozer !== undefined)) {
				result.parsedCorretly = true;
			}

			return true;
		}

		export function tryFacebook(result:ParseResult):boolean {
			let canvesFrame:Extended.Product = result.getFirstProductByName(ProductName.CanvasFrame);
			if (!canvesFrame) {
				return false;
			}

			if (result.parentBrowser !== ProductName.Chrome) {
				PandaConsole.errorUncritical(new PandaError('Facebook canvesFrame without Chrome', 135));
				return false;
			}

			result.browser = canvesFrame.browser;
			result.version = canvesFrame.version;
			result.versionNumber = canvesFrame.versionNumber;

			let index = result.userAgent.indexOf('FacebookCanvasDesktop');
			if (index >= 0) {
				result.browser = 'FacebookCanvasDesktop';
				result.parsedCorretly = true;
			}

			return true;
		}

		export function trySafari(result:ParseResult):boolean {
			if (result.products.length !== 4 && result.products.length !== 5) { // 5 for mobile
				return false;
			}
			let mobile:Extended.Product = result.getFirstProductByName(ProductName.Mobile);
			if (mobile && result.products.length !== 5) {
				return false;
			}
			let safari:Extended.Product = result.getFirstProductByName(ProductName.Safari);
			if (!safari) {
				return false;
			}
			let version:Extended.Product = result.getFirstProductByName(ProductName.Version);
			if (!version) {
				return false;
			}
		
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('Safari without Mozilla', 131));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('Safari with mozilla version !==5', 132));
				return false;
			}
			let webKit:Extended.Product = result.getFirstProductByName(ProductName.AppleWebKit);
			if (!webKit) {
				PandaConsole.errorUncritical(new PandaError('Safari without AppleWebKit', 133));
				return false;
			}

			result.browser = safari.browser;
			result.version = version.version;
			result.versionNumber = version.versionNumber;
			result.parentBrowser = safari.browser;
			result.parentVersion = version.version;
			result.parentVersionNumber = version.versionNumber;
			result.parsedCorretly = true;
			if (mobile) {
				result.mobileExperimental = true;
			}

			return false;
		}

		export function tryOneProductGoogleExtender(result:ParseResult):boolean {
			if (result.parentBrowser !== ProductName.Chrome) {
				return false;
			}

			if (result.products.length !== 5 ) {
				return false;
			}

			let knownProducts:number = 0;
			let unknownProduct:Extended.Product;
			for (let prod of result.products) {
				switch (prod.browser) {
					case ProductName.Chrome:
					case ProductName.Mozilla:
					case ProductName.Safari:
					case ProductName.AppleWebKit:
						knownProducts++;
						continue;
					default:
						unknownProduct = prod;
						break;
				}
			}

			if (knownProducts !== 4) {
				PandaConsole.errorUncritical(new PandaError('Chrome without Chrome/Mozilla/Safari/AppleWebKit', 136));
				return false;
			}

			result.browser = unknownProduct.browser;
			result.version = unknownProduct.version;
			result.versionNumber = unknownProduct.versionNumber;
			result.parsedCorretly = true;

			return true;
		}

		export function tryAol(result:ParseResult):boolean {
			if (result.parentBrowser !== ProductName.Chrome) {
				return false;
			}

			if (result.products.length !== 6 ) {
				return false;
			}

			let aol:Extended.Product = result.getFirstProductByName(ProductName.AOL);
			let aolBuild:Extended.Product = result.getFirstProductByName(ProductName.AOLBuild);

			if (!aol || !aolBuild) {
				return false;
			}

			result.browser = aol.browser;
			result.version = aolBuild.version;
			result.versionNumber = aolBuild.versionNumber;
			result.parsedCorretly = true;

			return true;
		}

		export function tryFirefox(result:ParseResult):boolean {
			let firefox:Extended.Product = result.getFirstProductByName(ProductName.Firefox);
			if (!firefox) {
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('Firefox without Mozilla', 136));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('Firefox with mozilla version !==5', 137));
				return false;
			}
			let gecko:Extended.Product = result.getFirstProductByName(ProductName.Gecko);
			if (!gecko) {
				PandaConsole.errorUncritical(new PandaError('Firefox without gecko', 138));
				return false;
			}

			result.browser = firefox.browser;
			result.version = firefox.version;
			result.versionNumber = firefox.versionNumber;
			result.parentBrowser = firefox.browser;
			result.parentVersion = firefox.version;
			result.parentVersionNumber = firefox.versionNumber;

			if (result.products.length === 3) {
				result.parsedCorretly = true;
			}
			return false;
		}

		export function tryAir(result:ParseResult):boolean {
			let air:Extended.Product = result.getFirstProductByName(ProductName.AdobeAIR);
			if (!air) {
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('AdobeAIR without Mozilla', 136));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('AdobeAIR with mozilla version !==5', 137));
				return false;
			}
			let webkit:Extended.Product = result.getFirstProductByName(ProductName.AppleWebKit);
			if (!webkit) {
				PandaConsole.errorUncritical(new PandaError('AdobeAIR without webkit', 138));
				return false;
			}

			result.browser = air.browser;
			result.version = air.version;
			result.versionNumber = air.versionNumber;
			result.parentBrowser = air.browser;
			result.parentVersion = air.version;
			result.parentVersionNumber = air.versionNumber;

			if (result.products.length === 3) {
				result.parsedCorretly = true;
			}
			return false;
		}

		export function tryPaleMoon(result:ParseResult):boolean {
			let paleMoon:Extended.Product = result.getFirstProductByName(ProductName.PaleMoon);
			if (!paleMoon) {
				return false;
			}
			let firefox:Extended.Product = result.getFirstProductByName(ProductName.Firefox);
			if (!firefox) {
				PandaConsole.errorUncritical(new PandaError('Palemoon without Firefox', 136));
				return false;
			}
			let mozilla:Extended.Product = result.getFirstProductByName(ProductName.Mozilla);
			if (!mozilla) {
				PandaConsole.errorUncritical(new PandaError('Palemoon without Mozilla', 136));
				return false;
			}
			if (mozilla.versionNumber !== 5) {
				PandaConsole.errorUncritical(new PandaError('Palemoon with mozilla version !==5', 137));
				return false;
			}
			let gecko:Extended.Product = result.getFirstProductByName(ProductName.Gecko);
			if (!gecko) {
				PandaConsole.errorUncritical(new PandaError('Palemoon without gecko', 138));
				return false;
			}

			result.browser = paleMoon.browser;
			result.version = paleMoon.version;
			result.versionNumber = paleMoon.versionNumber;
			result.parentBrowser = firefox.browser;
			result.parentVersion = firefox.version;
			result.parentVersionNumber = firefox.versionNumber;

			if (result.products.length === 5 || result.products.length === 5) {
				result.parsedCorretly = true;
			}
			return false;
		}

		export function tryOneProductFirefoxExtender(result:ParseResult):boolean {
			if (result.parentBrowser !== ProductName.Firefox) {
				return false;
			}

			if (result.products.length !== 4 ) {
				return false;
			}

			let knownProducts:number = 0;
			let unknownProduct:Extended.Product;
			for (let prod of result.products) {
				switch (prod.browser) {
					case ProductName.Mozilla:
					case ProductName.Gecko:
					case ProductName.Firefox:
						knownProducts++;
						continue;
					default:
						unknownProduct = prod;
						break;
				}
			}

			if (knownProducts !== 3) {
				PandaConsole.errorUncritical(new PandaError('Firefox  Mozilla/Gecko/Firefox', 139));
				return false;
			}

			result.browser = unknownProduct.browser;
			result.version = unknownProduct.version;
			result.versionNumber = unknownProduct.versionNumber;
			result.parsedCorretly = true;

			return true;
		}


		const _ieRexp:RegExp = /^MSIE ([^ ]+)$/;
		export function tryIE(result:ParseResult):boolean {
			let trident:Extended.Product = result.getFirstProductByName(ProductName.Trident);
			if (!trident) {
				return false;
			}

			let version:Extended.CommentVersionToken;
			let ieTest: Array<string>;
			for (let comment of result.comments) {
				if (!version && comment instanceof Extended.CommentVersionToken) {
					version = comment;
				}
				if (!ieTest) {
					ieTest = comment.raw.match(_ieRexp);
				}
			}

			if (version && version.versionNumber === 11) {
				result.parentBrowser = ProductName.MSIE;
				result.parentVersion = version.version;
				result.parentVersionNumber = version.versionNumber;
				result.browser = ProductName.MSIE;
				result.version = version.version;
				result.versionNumber = version.versionNumber;
				result.parsedCorretly = true;
				return true;
			}

			if (!ieTest || ieTest.length !== 2) {
				return false;
			}

			let versionString:string = ieTest[1];
			let versionNumber:number = parseFloat(versionString) || 0;

			result.parentBrowser = ProductName.MSIE;
			result.parentVersion = versionString;
			result.parentVersionNumber = versionNumber;
			result.browser = ProductName.MSIE;
			result.version = versionString;
			result.versionNumber = versionNumber;
			result.parsedCorretly = true;
			return true;
		}

		export function fillOSProperties(result:ParseResult):void {
			let parsedComments:Array<Extended.CommentToken> = result.comments
			let osParsed:boolean = false;
			for (let comment of parsedComments) {
				if (comment instanceof Extended.CommentOSToken) {
					if (osParsed) {
						continue;
					}
					result.osType = comment.osType;
					result.osName = comment.osName;
					result.osVersion = comment.osVersion;
					result.osVersionNumber = comment.osVersionNumber;
					result.archtecture = comment.architecture;
					if (result.osName === 'Android') {
						result.mobileExperimental = true;
					}
					osParsed = true;
				}
				if (comment instanceof Extended.CommentArchitectureToken) {
					if (result.archtecture !== 'unknown') {
						continue;
					}
					result.archtecture = comment.raw;
				}
			}
		}

		export function parseProducts(splitted:SplitterResult):Array<Extended.Product> {
			let parsedProducts:Array<Extended.Product> = [];
			for (let productString of splitted.products) {
				let product:Extended.Product = parseProduct(productString, false);
				if (product) {
					parsedProducts.push(product);
				}
			}
			return parsedProducts
		}

		export function parseComments(splitted:SplitterResult):Array<Extended.CommentToken> {
			let parsedComments:Array<Extended.CommentToken> = [];
			for (let commentString of splitted.comments) {
				let parsedComment:Array<Extended.CommentToken> = splitComment(commentString);
				parsedComments = parsedComments.concat(parsedComment);
			}
			return parsedComments;
		}


		export function splitAgent(agent: string, throwErrors:boolean): SplitterResult {
			const PRODUCT = 0;
			const COMMENT = 1;
			const UNKNOWN = 2;

			let result: SplitterResult = new SplitterResult();
			let comments: Array<string> = result.comments;
			let products: Array<string> = result.products;

			let state = UNKNOWN;
			let part: string = '';
			let commentOpenBrackets:number = 0;

			function writeAndReset():void {
				if (commentOpenBrackets !== 0) {
					if (throwErrors) {
						throw new SplitError('Reset with commentOpenBrackets !== 0', 100);
					} else {
						return null;
					}
				}
				if (state === COMMENT) {
					comments.push(part);
				}
				if (state === PRODUCT) {
					products.push(part);
				}
				part = '';
				state = UNKNOWN;
			}

			let debugStr:string = '';
			let l: number = agent.length;
			for (let i: number = 0; i < l; i++) {
				let char: string = agent.charAt(i);
				debugStr += char;
				if (state === UNKNOWN) {
					switch (char) {
						case '(':
							state = COMMENT;
							commentOpenBrackets++;
							continue;
						case ')':
							if (throwErrors) {
								throw new SplitError('Closed bracket in unnown state', 101);
							} else {
								return null;
							}
						case ' ':
							continue;
						default:
							state = PRODUCT;
							break;
					}
				}

				if (state === PRODUCT) {
					switch (char) {
						case '(':
						case ')':
							if (throwErrors) {
								throw new SplitError('Bracket while product parsing', 102);
							} else {
								return null;
							}
						case ' ':
							writeAndReset();
							continue;
						default:
							part += char;
							continue;
					}
				}

				if (state === COMMENT) {
					switch (char) {
						case '(':
							commentOpenBrackets++;
							part += char;
							continue;
						case ')': 
							commentOpenBrackets--;
							if (commentOpenBrackets === 0) {
								writeAndReset();
								continue;
							}
							if (commentOpenBrackets < 0) {
								if (throwErrors) {
									throw new SplitError('Logic error, commentOpenBrackets < 0', 103);
								} else {
									return null;
								}
							}
							part += char;
							continue;
						default:
							part += char;
							continue;
					}
				}
			}
			if (state === PRODUCT) {
				products.push(part);
			}
			if (state === COMMENT) {
				if (throwErrors) {
					throw new SplitError('Unexpected comment end', 104);
				} else {
					return null;
				}
			}
			return result;
		}

		// product like Chrome/46.0.2490.80
		export function parseProduct(product:string, throwErrors:boolean):Extended.Product {
			
			let name:string = '';
			let version:string = '';

			const NAME = 0;
			const VERSION = 1;
			const UNKNOWN = 2;

			let state:number = UNKNOWN;

			let debugStr:string = '';
			let l: number = product.length;
			for (let i: number = 0; i < l; i++) {
				let char: string = product.charAt(i);
				debugStr += char;

				if (state === UNKNOWN) {
					if (char === '/') {
						if (name.length === 0) {
							if (throwErrors) {
								throw new ParseProductError('No name before / in unknown state', 110)
							} else {
								return null;
							}
						}
						state = VERSION;
						continue;
					}
					state = NAME;
				}
				if (state === NAME) {
					if (char === '/') {
						if (name.length === 0) {
							if (throwErrors) {
								throw new ParseProductError('No name before / in name state', 111)
							} else {
								return null;
							}
						}
						state = VERSION;
						continue;
					}
					name += char;
					continue;
				}
				if (state === VERSION) {
					if (char === '/') {
						if (name === 'Nichrome' && version === 'self') { // Browser specific: Nichrome
							version = '';
							continue;
						}
						if (throwErrors) {
							throw new ParseProductError('Unexpected / in version state', 112)	
						} else {
							return null;
						}
					}
					version += char;
					continue;
				}
			}

			if (name.length === 0) {
				if (throwErrors) {
					throw new ParseProductError('No product name', 113);
				} else {
					return null;
				}
			}

			if (name === 'TO-Browser' && version.indexOf('TOB') === 0) {
				version = version.slice(3);
			}

			if (version.length === 0) {
				if (throwErrors) {
					throw new ParseProductError('No version', 114);
				} else {
					return null;
				}
			}

			let result:Extended.Product = new Extended.Product();
			result.raw = product;
			result.browser = name;
			result.version = version;
			result.versionNumber =  parseFloat(version) || 0;

			return result;
		}

		export function splitComment(comment:string):Array<Extended.CommentToken> {
			let result:Array<Extended.CommentToken> = [];
			let splitted = comment.split('; ');
			for (let part of splitted) {
				let token:Extended.CommentToken = null;
				token = tryParseOSToken(part) ||
						tryParseProductToken(part) ||
						tryParseVersionToken(part) ||
						tryParseAchitectureToken(part)||
						new Extended.CommentUnknownToken();
				token.raw = part;
				result.push(token);
			}
			return result;
		}

		export function tryParseAchitectureToken(str:string):Extended.CommentArchitectureToken {
			if (str === 'WOW64' || str === 'Win64' || str === 'x64') {
				return new Extended.CommentArchitectureToken();
			}
			return null;
		}

		export function tryParseProductToken(str:string):Extended.CommentProductToken {
			let parsed = parseProduct(str, false);
			if (!parsed) {
				return null;
			}
			let token = new Extended.CommentProductToken();
			token.product = parsed;
			return token;
		}

		export function tryParseVersionToken(str:string):Extended.CommentVersionToken {
			let splitResult:Array<string> = str.match(/rv\:(.*)/);
			if (splitResult && splitResult.length === 2) {
				let versionNumber:number = parseFloat(splitResult[1]);
				if (!isNaN(versionNumber)) {
					let result:Extended.CommentVersionToken = new Extended.CommentVersionToken();
					result.version = splitResult[1];
					result.versionNumber = versionNumber;
					return result;
				}
			}
			return null;
		}

		export function tryParseOSToken(str:string): Extended.CommentOSToken {
			let result:Extended.CommentOSToken = null;
			let splitResult:Array<string>
			//try { // Windows
				splitResult = str.match(/Windows NT ?(.*)/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					let version = splitResult[1];
					if (version === '') {
						version = 'unknown'
					}
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'Windows';
					let winNames:any = {
						"Windows NT 10.0":  "Windows 10",
						"Windows NT 6.3":	"Windows 8.1",
						"Windows NT 6.2":	"Windows 8",
						"Windows NT 6.1":	"Windows 7",
						"Windows NT 6.0":	"Windows Vista",
						"Windows NT 5.2":	"Windows Server 2003; Windows XP x64 Edition",
						"Windows NT 5.1":	"Windows XP",
						"Windows NT 5.01":	"Windows 2000 SP1",
						"Windows NT 5.0":	"Windows 2000",
						"Windows NT 4.0":	"Windows NT 4.0",
						"Windows NT":		"Windows Unknown"
					}
					let name:string = 'unknown';
					if (!winNames[str]) {
						PandaConsole.errorUncritical(new PandaError('Unknown windows name: ' + str, 150));
					} else {
						name = winNames[str];
					}

					result.osName = name;
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = 'unknown';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // OS X
				splitResult = str.match(/Intel Mac OS X (.*)/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					let version = splitResult[1].replace(/_/g,'.');
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'OS X'
					result.osName = 'Intel Mac OS X'
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = 'Intel Mac OS X';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { //Chrom OS
				splitResult = str.match(/CrOS ([^ ]+) (.*)/);
				if (splitResult && splitResult.length === 3) {
					result = new Extended.CommentOSToken();
					let version = splitResult[2];
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'Chrome OS'
					result.osName = 'Chrome OS'
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = splitResult[1];
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { //Linux
				splitResult = str.match(/Linux (.*)/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					result.osType = 'Linux'
					result.osName = 'Linux'
					result.osVersion = 'unknown';
					result.osVersionNumber = 0;
					result.architecture = splitResult[1];
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // CPU iPhone OS 9_3_2 like Mac OS X
				splitResult = str.match(/CPU iPhone OS (.*) like Mac OS X/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					let version = splitResult[1].replace(/_/g,'.');
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'iPhone';
					result.osName = 'iPhone';
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = 'iPhone';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // iOS
				if (str == 'iOS') {
					result = new Extended.CommentOSToken();
					result.osType = 'iOS';
					result.osName = 'iOS';
					result.osVersion = 'unknown';
					result.osVersionNumber = 0;
					result.architecture = 'Air';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // CPU OS 9_3_2 like Mac OS X //ipad
				splitResult = str.match(/CPU OS (.*) like Mac OS X/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					let version = splitResult[1].replace(/_/g,'.');
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'iPad';
					result.osName = 'iPad';
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = 'iPad';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // Android 4.4.2
				splitResult = str.match(/Android (.*)/);
				if (splitResult && splitResult.length === 2) {
					result = new Extended.CommentOSToken();
					let version = splitResult[1];
					let versionNumber = parseFloat(version) || 0;
					result.osType = 'Android'
					result.osName = 'Android'
					result.osVersion = version;
					result.osVersionNumber = versionNumber;
					result.architecture = 'Android';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			// try { // Android
				if (str == 'Android') {
					result = new Extended.CommentOSToken();
					result.osType = 'Android';
					result.osName = 'Android';
					result.osVersion = 'unknown';
					result.osVersionNumber = 0;
					result.architecture = 'Air';
					return result;
				}
			// } catch (e){
			// 	PandaConsole.errorUncritical(e)
			// };
			
			return result;
		}

		export class SplitterResult {
			public products: Array<string> = [];
			public comments: Array<string> = [];
		}
	}
}
